import { Tabs, Tab } from "@mui/material";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import { STATUS_META, BRAND_COLOR } from "../constants";

interface LeadsStatusTabsProps {
  data: LeadsManagementData;
}

export default function LeadsStatusTabs({ data }: LeadsStatusTabsProps) {
  const { status, statusOrder, setStatus } = data;

  return (
    <Tabs
      value={status}
      onChange={(_, value) => setStatus(value)}
      variant="scrollable"
      scrollButtons={false}
      sx={{
        mt: 2.75,
        borderBottom: "1px solid #e6e6e6",
        minHeight: 0,
        "& .MuiTab-root": {
          minHeight: 0,
          fontSize: 13.5,
          fontWeight: 500,
          letterSpacing: "0.5px",
          color: "#6b6b6b",
        },
        "& .Mui-selected": { color: `${BRAND_COLOR} !important` },
        "& .MuiTabs-indicator": { backgroundColor: BRAND_COLOR, height: 3 },
      }}
    >
      <Tab value="All" label="ALL" />
      {statusOrder.map((statusKey) => (
        <Tab key={statusKey} value={statusKey} label={STATUS_META[statusKey].label.toUpperCase()} />
      ))}
    </Tabs>
  );
}
